module.exports = __webpack_public_path__ + "static/img/share.ff5c517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/share.jpg
// module id = uv4T
// module chunks = 27